var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"profile-picture-limit-size",attrs:{"src":require(`@/assets/${_vm.picture || 'profile'}.png`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }